import { ProductListResponseV1 } from "@ucchub/ui/src/apiTypes/organisation";
import environment from "environment";
import { BaseService } from "@services/BaseService";
import { useState } from "react";
import { t } from "i18next";
import type { Product } from "@components/customer/Customer.types";

const useProductList = () => {
  const [productList, setProductList] = useState<Product[]>([]);

  const [error, setError] = useState<string>();
  const [isProductListLoading, setIsProductListLoading] = useState(false);

  const fetchProductList = () => {
    setIsProductListLoading(true);
    setError("");
    const apiUrl = environment.api.products;

    BaseService.get<ProductListResponseV1[]>(apiUrl)
      .then(({ data }) => {
        setProductList(data);
      })
      .catch(() => {
        setError(t("core:customers:fetch_product_list_failure") || undefined);
      })
      .finally(() => {
        setIsProductListLoading(false);
      });
  };

  return {
    productList,
    error,
    isProductListLoading,
    fetchProductList,
  };
};

export default useProductList;
